export default "__VITE_ASSET__742c4d35__"